export const establishWebSocketConnection = (userID = 23143) => {
  const ENDPOINT =
    // eslint-disable-next-line no-undef
    process.env.REACT_APP_NOTIFICATION_API ||
    'wss://dev-cdmis-v2-api.ideabreed.net/ws/notifications/';
  try {
    const ws = new WebSocket(ENDPOINT);
    const apiCall = {
      userID: userID
    };

    ws.onopen = () => {
      ws.send(JSON.stringify(apiCall));
    };
    return ws;
  } catch (error) {
    return null;
  }
};

export const establishCertificateWebSocketConnection = (token) => {
  const ENDPOINT =
    // eslint-disable-next-line no-undef
    process.env.REACT_APP_CERTIFICATE_URL;
  // 'wss://highlights-james-system-repository.trycloudflare.com/ws/certificates/';

  try {
    const ws = new WebSocket(ENDPOINT);
    const apiCall = {
      access: token
    };

    ws.onopen = () => {
      ws.send(JSON.stringify(apiCall));
    };

    return ws;
  } catch (error) {
    return null;
  }
};
